import 'fontsource-roboto/300.css'
import 'fontsource-roboto/400.css'
import 'fontsource-playfair-display/400.css'
import 'fontsource-playfair-display/700.css'

export const onClientEntry = async () => {
  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`);
  }
}